import { render, staticRenderFns } from "./printList.vue?vue&type=template&id=596db9f5&scoped=true"
import script from "./printList.vue?vue&type=script&lang=js"
export * from "./printList.vue?vue&type=script&lang=js"
import style0 from "./printList.vue?vue&type=style&index=0&id=596db9f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596db9f5",
  null
  
)

export default component.exports